import { observer, useViewModel } from '@descomplica/microfrontend-react';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';

import Loading from '@/presentation/components/loading';

import MultiStep from './components/multi-step';
import Result from './components/result';
import { ExamViewModel } from './exam.vm';

const Container = styled.div`
  width: 100%;
  font-family: 'Aprova Nova';
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  font-weight: normal;
  color: #111;
  background-color: #fff;
  border-radius: 8px;
  position: relative;
  height: auto;
  min-height: 100vh;

  @media (max-width: 480px) {
    position: static;
  }
`;

export const Exam: React.FC = () => {
  const vm = useViewModel(ExamViewModel);

  const { guid } = useParams();

  useEffect(() => {
    const loadExercises = async () => {
      if (guid) await vm.handleScreenEnter(guid);
    };

    loadExercises();
  }, [guid]);

  if (vm.isLoading) {
    return <Loading />;
  }

  return (
    <Container>
      {!vm.showResult ? (
        <MultiStep exercises={vm.exercises} />
      ) : (
        <Result exercises={vm.exercises} />
      )}
    </Container>
  );
};

window.addEventListener('beforeunload', (event) => {
  event.preventDefault();
  event.returnValue = '';
});

export default observer(Exam);
